import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-floating-bar',
	templateUrl: './floating-bar.component.html',
	styleUrls: ['./floating-bar.component.scss']
})
export class FloatingBarComponent {
	@Input() text = 'Procesando datos';
}
